<template>
  <div>
    <div class="position-relative w-100">
      <b-form-input
        readonly
        :value="selectedValue"
        class="pointer-cell"
        @click="showModal"
      />
      <div class="select-input-body-wrapper">
        <button type="button" class="custom-btn-select" @click.stop="onIconClick">
          <v-icon v-if="selected.length > 0" name="buttons/cross" :size="11"/>
          <v-icon v-else name="buttons/collapse_chevrons_right" :size="10"/>
        </button>
      </div>
    </div>

    <b-modal
      ref="work_type_multi_select_modal"
      body-class="modal-body-select"
      title="Виды работ"
      size="xl"
      modal-class="custom-modal"
      @close="onCancel"
      scrollable
    >
      <div class="page-body">
        <div class="page-filters">
          <div class="d-flex align-items-center">
            <b-input-group>
              <b-form-input size="sm" v-model="query" :placeholder="$t('message.common.search')"/>
              <b-input-group-append>
                <button type="button" class="search-btn" @click.stop="onSearch()">
                  <v-icon name="buttons/search"/>
                </button>
              </b-input-group-append>
            </b-input-group>
          </div>
        </div>

        <template v-if="isBusy || (filteredItems.items && filteredItems.total > 0)">
          <div class="page-table-container">
            <b-table
              ref="work_type_table"
              class="custom-table text-small mb-0"
              responsive
              :items="filteredItems.items"
              :fields="fields"
              :busy="isBusy"
              :tbody-tr-class="tbodyRowClass"
              @row-clicked="rowClicked"
            >
              <template #table-busy>
                <tables-skeleton :fields="fields" :rows="5"/>
              </template>
            </b-table>
          </div>

          <div class="page-pagination">
            <pagination-footer
              :total-rows="filteredItems.total"
              :per-page="perPage"
              :current-page="currentPage"
              @page-change="(page) => onPagination(null, page)"
              @per-page-change="onPerPageChange"
            />
          </div>
        </template>

        <div v-else class="empty-state-container">
          <v-icon name="navbar/empty_table" :size="90"/>
          <h5>{{ isFiltered ? 'Нет данных соответствующих фильтрам.' : 'Нет добавленных исполнителей.' }}</h5>
        </div>
      </div>

      <template #modal-footer>
        <div class="d-flex justify-content-between w-100">
          <p class="float-left">Выбраны: {{ tempSelected.length }}</p>
          <b-button class="custom-btn-primary" @click="onOk">
            Применить
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import catalogs from "../../../network/catalogs";
  import helpers from "../../../utilites/helpers";
  import PaginationFooter from "../../../utilites/commonUi/PaginationFooter.vue";
  import pageSearchService from "../../../utilites/pageSearchService";
  import TablesSkeleton from "../../../utilites/commonUi/TablesSkeleton.vue";

export default {
  name: "WorkTypeMultiSelect",
  components: { TablesSkeleton, PaginationFooter },
  mixins: [
    catalogs,
    helpers, pageSearchService
  ],
  props: {
    value: { type: Array, default: () => [] }
  },
  data() {
    return {
      query: '',
      items: [],
      selected: [],
      tempSelected: [],
      isBusy: false,
      fields: [
        {
          key: 'id',
          label: 'ID',
          class: 'text-center',
        },
        {
          key: 'name',
          label: 'Название'
        }
      ]
    }
  },
  computed: {
    filteredItems() {
      const query = this.query.trim().toLowerCase();

      const filtered = query ? this.items.filter(i => String(i.name).toLowerCase().includes(query) || String(i.id).includes(query)) : this.items;

      const start = (this.currentPage - 1) * this.perPage;
      const ids = new Set(this.tempSelected.map(e => e.id));

      const paginated = filtered.slice(start, start + this.perPage).map(item => ({
        ...item,
        selected: ids.has(item.id)
      }));

      return {
        items: paginated,
        total: filtered.length
      };
    },
    selectedValue() {
      if (!this.selected.length) return "Все виды работ";
      return this.selected.length <= 2 ? this.selected.map(i => i.name).join(", ") : "Выбрано: " + this.selected.length;
    },
    isFiltered() {
      return !!this.query && this.query.trim().length > 0;
    },
  },
  watch: {
    query() {
      this.currentPage = 1;
    },
    value(newVal) {
      if (!newVal || newVal.length === 0) {
        this.selected = [];
        this.tempSelected = [];
      }
    }
  },
  async mounted() {
    await this.getItems();

    if (this.value.length) await this.configure(this.value);
  },
  methods: {
    async configure(ids) {
      if (!ids || !ids.length) return;

      const result = await Promise.all(ids.map(id => this.getWorkTypeById(id)));
      this.selected = result.filter(r => r && r.data).map(r => r.data);
    },
    async getItems() {
      if (this.items.length) return;

      this.isBusy = true;
      const result = await this.getWorkTypeCatalogs({});

      if (result && result.data) {
        this.items = result.data.items;
        this.totalRows = this.items.length;
      }

      this.isBusy = false;
    },
    async showModal() {
      this.tempSelected = [...this.selected];
      this.$refs.work_type_multi_select_modal.show();
      await this.getItems();
    },
    rowClicked(item) {
      const existItem = this.tempSelected.findIndex(e => e.id === item.id);

      if (existItem !== -1) {
        this.tempSelected.splice(existItem, 1);
        item.selected = false;
      } else {
        this.tempSelected.push(item);
        item.selected = true;
      }
    },
    tbodyRowClass(item) {
      return item && item.selected ? ["b-table-row-selected", "table-primary", "pointer-cell"] : ["pointer-cell"];
    },
    onOk() {
      this.selected = [...this.tempSelected];
      this.$emit('input', this.selected.map(i => i.id));
      this.$emit('onSelect', this.selected);
      this.$refs.work_type_multi_select_modal.hide();
    },
    onCancel() {
      this.tempSelected = [];
      this.query = '';
    },
    onClear() {
      this.selected = [];
      this.$emit('input', []);
      this.$emit('onSelect', []);
    },
    onIconClick() {
      if (this.selected.length) {
        this.onClear();
      } else {
        this.showModal();
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Catalogs/WorkType/WorkTypeMultiSelect.vue